import { render } from "./index.vue?vue&type=template&id=6092d8d2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=6092d8d2&lang=less&scoped=true"

import exportComponent from "/Users/ryancompany/works/bao/xinyuanyiyuan/pet-mobile-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6092d8d2"]])

export default __exports__